import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-right: ", ";\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tcolor: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tbottom: 0;\n\tdisplay: flex;\n\tjustify-content: center;\n\tpadding: 0 5px;\n\tpointer-events: none;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: 8px;\n\tpadding-right: 30px;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: 0;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
import { FlexItem } from '../Flex';
export var ARROW_WRAPPER_WIDTH = 24;
export var base = css(_templateObject());
export var select = css(_templateObject2());
export var ArrowWrapperView = styled(FlexItem)(_templateObject3());
export var placeholder = css(_templateObject4(), ui.get('colorTextMuted'));
export var arrowPadding = css(_templateObject5(), ui.value.px(ARROW_WRAPPER_WIDTH));
export var Suffix = css(_templateObject6());